import { useEffect, useState } from "react";

const links = [
  { id: "problem", label: "The Problem" },
  { id: "insight", label: "The Insight" },
  { id: "services", label: "Services" },
  { id: "about", label: "About Rachel" },
];

export default function Nav({ onContactOpen }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F9F6F0]/90 backdrop-blur-xl border-b border-[#E2DCD0]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-brand"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-display text-xl md:text-2xl tracking-tight text-[#0F172A] leading-none"
        >
          All We Do <span className="italic text-[#C86A53]">Is Write</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="awd-link text-sm font-medium tracking-wide text-[#0F172A]/80 hover:text-[#0F172A]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta"
            onClick={onContactOpen}
            className="hidden sm:inline-flex items-center justify-center px-5 py-2.5 text-xs uppercase tracking-[0.18em] font-semibold bg-[#0F172A] text-[#F9F6F0] hover:bg-[#C86A53] transition-colors duration-300"
          >
            Let's Talk
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Toggle menu"
            className="md:hidden w-10 h-10 inline-flex items-center justify-center text-[#0F172A]"
          >
            <span className="block w-5 h-px bg-current relative before:content-[''] before:absolute before:-top-1.5 before:left-0 before:w-5 before:h-px before:bg-current after:content-[''] after:absolute after:top-1.5 after:left-0 after:w-5 after:h-px after:bg-current" />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-[#E2DCD0] bg-[#F9F6F0]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left font-display text-2xl text-[#0F172A]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta"
              onClick={() => {
                setMobileOpen(false);
                onContactOpen();
              }}
              className="mt-2 inline-flex items-center justify-center px-5 py-3 text-xs uppercase tracking-[0.18em] font-semibold bg-[#C86A53] text-[#F9F6F0]"
            >
              Let's Talk About Growth
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
